import { z } from "zod";

export const cursorPositionSchema = z.object({
  x: z.number().finite(),
  y: z.number().finite(),
});
